import React from 'react';
import { Link } from 'react-router-dom';

const VARIANTS = {
  primary: 'bg-signal text-signal-ink border-signal font-semibold hover:bg-signal/90',
  secondary: 'bg-sheet text-ink border-rule hover:bg-hover',
  ghost: 'bg-transparent text-ink border-transparent hover:bg-hover',
};

const SIZES = {
  md: 'h-8 text-body gap-1.5',
  sm: 'h-7 text-small gap-1',
};

const PADDING = { md: 'px-3', sm: 'px-2.5' };
const SQUARE = { md: 'w-8', sm: 'w-7' };

export const buttonClass = ({ variant = 'secondary', size = 'md', square = false, className = '' } = {}) =>
  [
    'inline-flex items-center justify-center shrink-0 whitespace-nowrap rounded-control border',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    VARIANTS[variant],
    SIZES[size],
    square ? SQUARE[size] : PADDING[size],
    className,
  ].join(' ');

// Renders a router Link with `to`, an external link with `href`, otherwise a button.
export default function Button({ variant, size, square, className, to, href, children, type = 'button', ...rest }) {
  const classes = buttonClass({ variant, size, square, className });

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={classes} {...rest}>
        {children}
      </a>
    );
  }
  return (
    // eslint-disable-next-line react/button-has-type
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
